import {Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material";
import {dateToString, toTimeOnly} from "../../../Utils/dateUtils";

const EventDetail = ({event}) => {

    return (
        <TableContainer>
            <Table aria-label="event detail">
                <TableBody>
                    <TableRow>
                        <TableCell><b>Product Name</b></TableCell>
                        <TableCell>{event.product_name} ({event.product_abbreviation})</TableCell>
                        <TableCell><b>Total Participants</b></TableCell>
                        <TableCell>{event.participants_count?.Total}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell><b>Event Name</b></TableCell>
                        <TableCell>{event.event_name}</TableCell>
                        <TableCell><b>Event Location</b></TableCell>
                        <TableCell>{event.event_location}</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell><b>Event Date</b></TableCell>
                        <TableCell>{dateToString(new Date(event?.event_start))}</TableCell>
                        <TableCell><b>Event Time</b></TableCell>
                        <TableCell>{toTimeOnly(new Date(event?.event_start))} - {toTimeOnly(new Date(event?.event_stop))}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default EventDetail;